@if (isLoading() || isLoggingOut()) {
  <onrsr-loader [fullScreen]="true" [size]="'large'" />
} @else if (!isAuthenticated()) {
  <router-outlet />
} @else {
  <onrsr-layout>
    <router-outlet />
  </onrsr-layout>
}